import { SpeedInsights } from '@vercel/speed-insights/react';
import { createRoot } from 'react-dom/client';
import App from './App';

import 'normalize.css';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <>
    <App />
    {import.meta.env.PROD && <SpeedInsights />}
  </>,
);

if (import.meta.env.PROD) {
  requestIdleCallback(async () => {
    const [Sentry, posthog] = await Promise.all([
      import('@sentry/react'),
      import('posthog-js'),
    ]);

    Sentry.init({
      dsn: 'https://bc868b4513736d74a8b06dbc7a7e6d0d@o4506765311082496.ingest.us.sentry.io/4510487022075904',
      sendDefaultPii: true,
    });

    posthog.default.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    });
  });
}
